module.exports = __webpack_public_path__ + "img/bilibil.48e7d939.png";